module.exports = __webpack_public_path__ + "assets/img/successRegister.23efbf6f.png";